import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {PlannerComponent} from './planner/planner.component';

const routes: Routes = [
  { path: 'planner', component: PlannerComponent },
  { path: 'planner/:id', component: PlannerComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlannerRoutingModule { }
